import { FeatureFlag } from '@/types/featureFlag';

export const PATIENT_DETAILS_LAYOUT_FLAGS = {
    calendarRail: FeatureFlag.DASHBOARD_PATIENT_DETAILS_CALENDAR_RAIL,
    layoutV2: FeatureFlag.DASHBOARD_PATIENT_DETAILS_LAYOUT_V2,
};
